/******/ (() => { // webpackBootstrap
/* eslint-disable */
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.cacheDOMElements();
      this.bindEventHandlers();
    }

    cacheDOMElements() {
      /* ===== We need to cache the DOM elements in the constructor because the connectedCallback is called every time the element 
      is appended into the DOM ===== */
      this.input = this.querySelector('input');
      this.buttonMinus = this.querySelector("button[name='minus']");
      this.buttonPlus = this.querySelector("button[name='plus']");
      this.sectionId = this.getAttribute('data-section-id');
    }

    bindEventHandlers() {
      /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
      this.attachEventListeners = this.attachEventListeners.bind(this);
      this.detachEventListeners = this.detachEventListeners.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onInput = this.debounce(this.onInput.bind(this), 500);
      this.onCartAdded = this.onCartAdded.bind(this);
    }

    connectedCallback() {
      this.attachEventListeners();
      this.clampQuantity();
      this.updateButtons();
    }

    attachEventListeners() {
      /* ===== Attach the event listeners to the DOM elements ===== */
      this.buttonMinus.addEventListener('click', this.onButtonClick);
      this.buttonPlus.addEventListener('click', this.onButtonClick);
      this.input.addEventListener('input', this.onInput);
      eventBus.on('cart:added', this.onCartAdded);
    }

    debounce(func, wait, immediate) {
      /* ===== Debounce function to limit the rate at which a function is called ===== */
      let timeout;
      return function executedFunction() {
        const context = this;
        const args = arguments;
        
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    onButtonClick(event) {
      /* ===== Handle the button click event ===== */
      event.preventDefault();
      const previousValue = this.input.value;
      const adjustment = event.currentTarget.name === 'plus' ? 1 : -1;

      // Adjust the quantity by the adjustment value
      this.adjustQuantity(adjustment);
      // Emit the qty:change event if the value has changed
      if (previousValue !== this.input.value) eventBus.emit('qty:change', { value: this.input.value, sectionId: this.sectionId });
    }

    getMinQuantity() {
      return this.input.min ? parseInt(this.input.min, 10) : 1;
    }

    getMaxQuantity() {
      return this.input.max ? parseInt(this.input.max, 10) : null;
    }

    clampQuantity() {
      const min = this.getMinQuantity();
      const max = this.getMaxQuantity();
      let value = parseInt(this.input.value, 10);

      if (isNaN(value)) {
        value = min;
      }

      if (value < min) {
        value = min;
      }

      if (max !== null && value > max) {
        value = max;
      }

      this.input.value = value;
      this.updateButtons();
    }

    updateButtons() {
      const value = parseInt(this.input.value, 10);
      const min = this.getMinQuantity();
      const max = this.getMaxQuantity();

      if (this.buttonMinus) {
        this.buttonMinus.disabled = value <= min;
      }

      if (this.buttonPlus) {
        this.buttonPlus.disabled = max !== null && value >= max;
      }
    }

    onInput(event) {
      /* ===== Handle the input event ===== */
      event.preventDefault();
      this.clampQuantity();

      // Emit the qty:change event
      eventBus.emit('qty:change', { value: this.input.value, sectionId: this.sectionId });
    }

    adjustQuantity(adjustment) {
      /* ===== Adjust the quantity by the adjustment value ===== */
      const newValue = parseInt(this.input.value, 10) + adjustment;
      this.input.value = isNaN(newValue) ? this.getMinQuantity() : newValue;
      this.clampQuantity();
    }

    onCartAdded(data) {
      /* ===== Handle the cart:added event and reset the input value to min ===== */
      if (data.sectionId && data.sectionId === this.sectionId) {
        this.input.value = this.getMinQuantity();
        this.updateButtons();
      }
    }

    disconnectedCallback() {
      /* ===== Detach the event listeners when the element is removed from the DOM ===== */
      this.detachEventListeners();
    }

    detachEventListeners() {
      /* ===== Detach the event listeners from the DOM elements ===== */
      this.buttonMinus.removeEventListener('click', this.onButtonClick);
      this.buttonPlus.removeEventListener('click', this.onButtonClick);
      this.input.removeEventListener('input', this.onInput);
    }
  });
}
/******/ })()
;